// extracted by mini-css-extract-plugin
export var video = "Video-module--video--1c0AP";
export var sectionTitle = "Video-module--sectionTitle--Y17JM";